<div>
    <div class="container">
      <div>
        <h1>Wartung</h1>
        <div style="margin: 15px 0;">
          <h2 >
            Unsere Entwickler arbeiten auf Hochtouren daran, diese Seite schnellstmöglich wieder zur Verfügung zu stellen.
          </h2>
        </div>
      </div>
    </div>
</div>